<div
    class="st-attachments-list-item"
    draggable="true"
    [matTooltip]="attachment()?.description"
    (dragstart)="dragStart($event)">
    <div class="st-attachments-list-item-file-header">
        <mat-icon fontSet="material-symbols-outlined">
            {{ mosTypeIcon() }}
        </mat-icon>
        <div
            class="st-attachments-list-item-file-header__title"
            [matTooltip]="attachment()?.slugText">
            {{ attachment()?.slugText }}
        </div>
        <st-external-actions-overlay
            isAttachmentPoolItem
            editable
            [attachmentPoolItemData]="attachment()"
            [data]="data()"
            [disabled]="disabled()" />
        <!-- TODO: need to refactor this part in the external actions overlay -->
    </div>
    <div
        class="st-attachments-list-item-file-container"
        (click)="attachmentClick()">
        @if (attachment()?.url) {
            @switch (attachment()?.objType) {
                @case (MosObjectType.STILL) {
                    <img
                        class="st-attachments-list-item__img"
                        fill
                        [ngSrc]="attachment()?.url" />
                }
                @case (MosObjectType.VIDEO) {
                    @if (attachment()?.videoUrl) {
                        <video
                            class="st-attachments-list-item__video"
                            [src]="attachment()?.videoUrl"></video>
                    } @else {
                        <img
                            class="st-attachments-list-item__img"
                            fill
                            [ngSrc]="attachment()?.url" />
                    }
                }
                @case (MosObjectType.AUDIO) {
                    <audio
                        controls
                        class="st-attachments-list-item__audio"
                        controlsList="noplaybackrate nodownload">
                        <source [src]="attachment()?.url" />
                    </audio>
                }
            }
        } @else {
            <div class="st-attachments-list-item__placeholder">
                <mat-icon fontSet="st-icons">mat-icon-object-placeholder</mat-icon>
            </div>
        }

        @if (mosStatus()) {
            <div
                class="st-attachments-list-item__status"
                [matTooltip]="mosStatus()"
                [ngClass]="mosStatusClass()">
                {{ mosStatus() }}
            </div>
        }
    </div>
</div>
